// @flow
import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';
import { updateCurrentReferenceLayer } from './';
import type { ThunkAction, ReferenceLayer } from '../../types';

export function getReferenceLayers(): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/reference-layers';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId
      }
    };

    return makeAPICall(endpoint, options).then(
      response =>
        dispatch({
          type: 'UPDATE_REFERENCE_LAYERS',
          referenceLayers: response.data.referenceLayers
        }),
      error => dispatch(APIError(error, 'Error getting Reference Layers'))
    );
  };
}

export function getReferenceLayer(referenceLayerId: number): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/reference-layers/${referenceLayerId}`;
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId }
    };

    return makeAPICall(endpoint, options).then(
      response => response.data.referenceLayer,
      error => dispatch(APIError(error, 'Error getting Reference Layer'))
    );
  };
}

export function updateReferenceLayer(
  referenceLayer: ReferenceLayer
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/reference-layers/${referenceLayer.id}`;
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: referenceLayer
    };
    return makeAPICall(endpoint, options).then(
      response => {
        dispatch(getReferenceLayers());
        dispatch(updateCurrentReferenceLayer(referenceLayer.id));
        return response;
      },
      error => dispatch(APIError(error, 'Error updating Reference Layer'))
    );
  };
}

export function deleteReferenceLayer(
  referenceLayerId: ReferenceLayer
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/reference-layers/${referenceLayerId}`;
    const options = {
      method: 'DELETE',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        dispatch(getReferenceLayers());
        return response;
      },
      error => dispatch(APIError(error, 'Error updating Reference Layer'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/referenceLayers/basicCreators.js